import { combineReducers } from "@reduxjs/toolkit"
import userReducer from "./users.slice"
import roleReducer from "./roles.slice"

const OrganizationReducer = combineReducers({ users: userReducer, roles: roleReducer })

export default OrganizationReducer
